import React from "react";
import { WidgetContainer, WidgetView } from 'components/shared';
import { useModel, useRoute, BrandingDisabledIf } from "bcms-react";
import { PrimaryButton } from "components/ui";
import Util from "classes/Util";

import "./styles.css";
import "./mobile.css";

/**
 * @function ManageCardsWidget
 * @return {React.Component}
 * @exported true
 * @description This is the manage cards widget
 */
export default function ManageCardsWidget(props) {
    const navigate = useRoute();

    const onManageCardsMobileClick = () => {
        if(Util.inMabi) {
            Util.openABI22StandaloneOverlayInMABI23();
        } else {
            navigate("/ch21");
        }
    }

    return (
        <WidgetContainer className="manage-cards-widget">
            <WidgetView>
                <div className="flex-container flex-horizontal align-center">
                    <p className="set-width"><span>View, pay, and manage your credit and debit cards.</span></p>

                    <BrandingDisabledIf id="chw23_courseid_abi22" exp={ value => value !== null && value !== undefined }>
                        <PrimaryButton className="show-on-desktop" text="Manage Cards" onClick={ evt => navigate("/chw23") } dataPoint="manage_cards_button" />
                    </BrandingDisabledIf>

                    <BrandingDisabledIf id="ch21_courseid_abi22" exp={ value => value !== null && value !== undefined }>
                        <PrimaryButton className="show-on-mobile" text="Manage Cards" onClick={ onManageCardsMobileClick }  dataPoint="manage_cards_button" />
                    </BrandingDisabledIf>
                </div>
            </WidgetView>
        </WidgetContainer>
    )
}
